"use strict";

define(['mw-remote/RemoteEndPointsManager', 'dojo/_base/Deferred'], function (RemoteEndPointsManager, Deferred) {
  var sendDataUsingIFrame = function sendDataUsingIFrame(data, endPoint, options) {
    var iframeProxyClient = RemoteEndPointsManager.getIframeProxyClientForEndPoint(endPoint);
    return iframeProxyClient.sendMessage(data, RemoteEndPointsManager.getRemoteUrlForEndPoint(endPoint), options);
  };
  /**
   * Utility function to select the implementation to be used to send data to the server
   * Determines whether or not IFrame is needed for a partciular endpoint.
   */


  return {
    /**
     * This method is used to send thoptionse data. It fetches iframeProxyClient from the
     * RemoteEndPointsManager and
     * sends the message.
     * @param {object} data - data to send
     * @param {object} endPoint - endPoint to which the data is to be sent
     * @param {object} options - optional headers
     * @return {*} a promise
     */
    sendPayload: function sendPayload(data, endPoint, options) {
      var messageResponse = new Deferred();
      var result = sendDataUsingIFrame(data, endPoint, options);
      result.then(function (responseData) {
        messageResponse.resolve(responseData);
      });
      return messageResponse;
    }
  };
});
//# sourceMappingURL=SendMessageUtil.js.map
